/** Reflect theme and locale on <html>: dark/light class, color-scheme, lang; follow OS scheme changes */

import { useEffect } from 'react'
import { useAppStore } from '../stores/app-store'
import { applyThemeToDocument, SYSTEM_DARK_QUERY } from '../lib/theme'

/** Call once at the app root so every route (legacy and new shell) gets the same behavior */
export function useDocumentPreferences(): void {
  const theme = useAppStore((s) => s.theme)
  const themePreference = useAppStore((s) => s.themePreference)
  const refreshSystemTheme = useAppStore((s) => s.refreshSystemTheme)
  const locale = useAppStore((s) => s.locale)

  useEffect(() => {
    applyThemeToDocument(theme)
  }, [theme])

  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])

  // Only listen to the OS scheme while the user follows it
  useEffect(() => {
    if (themePreference !== 'system' || typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(SYSTEM_DARK_QUERY)
    refreshSystemTheme()
    mql.addEventListener('change', refreshSystemTheme)
    return () => mql.removeEventListener('change', refreshSystemTheme)
  }, [themePreference, refreshSystemTheme])
}
